import { createSelector } from 'reselect';
import { initialState } from './reducer';

/**
 * Direct selector to the courseDetailMobile state domain
 */

const selectCourseDetailMobileDomain = state =>
  state.courseDetailMobile || initialState;

/**
 * Other specific selectors
 */

const makeSelectLoading = () =>
  createSelector(
    selectCourseDetailMobileDomain,
    substate => substate.loading,
  );

const makeSelectError = () =>
  createSelector(
    selectCourseDetailMobileDomain,
    substate => substate.error,
  );

const makeSelectId = () =>
  createSelector(
    selectCourseDetailMobileDomain,
    substate => substate.id,
  );

const makeSelectFirstRender = () =>
  createSelector(
    selectCourseDetailMobileDomain,
    substate => substate.firstRender,
  );

const makeSelectCourseDetail = () =>
  createSelector(
    selectCourseDetailMobileDomain,
    substate => substate.courseDetail,
  );

/**
 * Default selector used by Courses
 */

const makeSelectCourseDetailMobile = () =>
  createSelector(
    selectCourseDetailMobileDomain,
    substate => substate,
  );

export default makeSelectCourseDetailMobile;
export {
  selectCourseDetailMobileDomain,
  makeSelectId,
  makeSelectFirstRender,
  makeSelectLoading,
  makeSelectError,
  makeSelectCourseDetail,
};
